// Generated by Melange

import * as Buhta_landing__Api from "../../../../core/Api.js";
import * as Buhta_landing__Content from "../../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../../components/html/Link.js";
import * as Buhta_landing__Route from "../../../../Route.js";
import * as Buhta_models__Locale from "../../../../../../../packages/models/Locale.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Company(Props) {
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const aboutPage = match[0].aboutPage;
  React.useEffect((function () {
    const __x = $$Promise.all({
      hd: Buhta_landing__Api.aboutPage(languageStr),
      tl: /* [] */ 0
    });
    $$Promise.get(__x, (function (respList) {
      Stdlib__List.iter((function (res) {
        Buhta_landing__Api.handleResponse(res, dispatchContent, undefined);
      }), respList);
    }));
  }), [language]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h2", {
        children: aboutPage.title,
        className: "h4 lg:h2 text-black-landing"
      }),
      JsxRuntime.jsx("p", {
        children: aboutPage.paragraph,
        className: "paragraph text-black-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsx("p", {
        children: aboutPage.subtext,
        className: "paragraph text-gray-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsx("div", {
        className: "mt-6 lg:mt-10 h-44.25 lg:h-80 bg-cover bg-center bg-company"
      }),
      JsxRuntime.jsx("h2", {
        children: aboutPage.title_2,
        className: "h4 lg:h2 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: aboutPage.paragraph_2,
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsx("h4", {
        children: aboutPage.list_title,
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: "Ранний доступ к заработной плате.",
        className: "paragraph text-gray-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/calendar-today.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_1,
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-4 lg:mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/clock24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_2,
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/card24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_3,
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/personal-support.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_4,
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-2"
      }),
      JsxRuntime.jsx(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Payroll */ 16
        },
        className: "paragraph text-primary mt-4 lg:mt-6 inline-block underline",
        children: Buhta_landing__I18n.trans(intl, "learn_more")
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h4", {
        children: aboutPage.list_title_2,
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: "Упростите процессы взаимодействия с клиентами.",
        className: "paragraph text-gray-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/key-black-24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_2_1,
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-4 lg:mt-6 flex items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/contract.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_2_2,
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-2 flex items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/chat.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_2_3,
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/sign-black-24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.list_item_2_4,
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-2"
      }),
      JsxRuntime.jsx(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* ESF */ 15
        },
        className: "paragraph text-primary mt-4 lg:mt-6 inline-block underline",
        children: Buhta_landing__I18n.trans(intl, "learn_more")
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h4", {
        children: "Онлайн-касса",
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: "Оптимизируйте процесс выдачи чека и освободите ресурсы для более важных задач.",
        className: "paragraph text-gray-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/cloud-connect.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Возможность подключения по API;",
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-4 lg:mt-6 flex items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/receipt.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Высокая пропускная способность с возможностью выбивать неограниченное количество чеков в день;",
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-2 flex items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/1c.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Интеграция с 1С.",
            className: "paragraph text-black-landing"
          })
        ],
        className: "flex m-auto mt-2"
      }),
      JsxRuntime.jsx(Buhta_landing__Link.make, {
        route: {
          TAG: /* Landing */ 0,
          _0: country,
          _1: language,
          _2: /* Kassa */ 13
        },
        className: "paragraph text-primary mt-4 lg:mt-6 inline-block underline",
        children: Buhta_landing__I18n.trans(intl, "learn_more")
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h4", {
        children: "Бухта Финансы",
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: "Кредитование на оборотные средства.",
        className: "paragraph text-gray-landing mt-2 whitespace-pre-line"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/cash24.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Мгновенный займ от Бухты за считанные минуты;",
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-4 lg:mt-6 flex items-center"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6 mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/send-mail.svg")
          }),
          JsxRuntime.jsx("p", {
            children: "Договор займа в электронном виде, подписание по СМС-коду.",
            className: "paragraph text-black-landing"
          })
        ],
        className: "mt-2 flex items-center"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h4", {
        children: aboutPage.how_title,
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/check-green.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.how_item_1,
            className: "paragraph text-black-landing lg:w-138"
          })
        ],
        className: "flex mt-4 lg:mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/check-green.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.how_item_2,
            className: "paragraph text-black-landing lg:w-138"
          })
        ],
        className: "flex mt-4"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "mr-4 shrink-0",
            src: StaticAsset.src("/static/icons/check-green.svg")
          }),
          JsxRuntime.jsx("p", {
            children: aboutPage.how_item_3,
            className: "paragraph text-black-landing lg:w-138"
          })
        ],
        className: "flex mt-4"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("h4", {
        children: aboutPage.who_title,
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsx("p", {
        children: aboutPage.who_subtitle,
        className: "paragraph text-black-landing mt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-26 -ml-4 h-26",
            alt: "jusan",
            src: StaticAsset.src("/static/icons/jusan-circle.svg")
          }),
          JsxRuntime.jsx("img", {
            className: "w-26 h-26",
            alt: "yandex taxi",
            src: StaticAsset.src("/static/images/yandex-taxi.png")
          }),
          JsxRuntime.jsx("img", {
            className: "w-26",
            src: StaticAsset.src("/static/icons/glovo-circled.svg")
          }),
          JsxRuntime.jsx("img", {
            className: "w-26 h-26",
            alt: "indrive",
            src: StaticAsset.src("/static/icons/indrive.svg")
          }),
          JsxRuntime.jsx("img", {
            className: "w-26 h-26",
            alt: "indrive",
            src: StaticAsset.src("/static/icons/one-two-trip.svg")
          })
        ],
        className: "flex mt-4 items-start"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider lg:mt-4"
      }),
      JsxRuntime.jsx("h4", {
        children: aboutPage.media_title,
        className: "h4 text-black-landing mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: aboutPage.media_text_1,
                className: "paragraph text-primary inline-block underline",
                href: aboutPage.media_link_1,
                target: "__blank"
              }),
              JsxRuntime.jsx("p", {
                children: aboutPage.media_name_1,
                className: "paragraph text-gray-landing mt-2"
              })
            ],
            className: "lg:w-70"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: aboutPage.media_text_2,
                className: "paragraph text-primary inline-block underline",
                href: aboutPage.media_link_2,
                target: "__blank"
              }),
              JsxRuntime.jsx("p", {
                children: aboutPage.media_name_2,
                className: "paragraph text-gray-landing mt-2"
              })
            ],
            className: "mt-4 lg:mt-0 lg:w-70"
          })
        ],
        className: "block lg:flex justify-between mt-4 lg:mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: aboutPage.media_text_3,
                className: "paragraph text-primary inline-block underline",
                href: aboutPage.media_link_3,
                target: "__blank"
              }),
              JsxRuntime.jsx("p", {
                children: aboutPage.media_name_3,
                className: "paragraph text-gray-landing mt-2"
              })
            ],
            className: "lg:w-70"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: aboutPage.media_text_4,
                className: "paragraph text-primary inline-block underline",
                href: aboutPage.media_link_4,
                target: "__blank"
              }),
              JsxRuntime.jsx("p", {
                children: aboutPage.media_name_4,
                className: "paragraph text-gray-landing mt-2"
              })
            ],
            className: "mt-4 lg:mt-0 lg:w-70"
          })
        ],
        className: "block lg:flex justify-between mt-4 lg:mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: "«Названы лучшие финансовые директора Казахстана»",
                className: "paragraph text-primary inline-block underline",
                href: "https://forbes.kz//life/hero/nazvanyi_luchshie_finansovyie_direktora_kazahstana/",
                target: "__blank"
              }),
              JsxRuntime.jsx("p", {
                children: "forbes.kz",
                className: "paragraph text-gray-landing mt-2"
              })
            ],
            className: "lg:w-70"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("a", {
                children: "«Как начать свой бизнес: рекомендации опытных предпринимателей»",
                className: "paragraph text-primary inline-block underline",
                href: "https://forbes.kz//process/businessmen/kak_nachat_svoy_biznes_rekomendatsii_opyitnyih_predprinimateley/",
                target: "__blank"
              }),
              JsxRuntime.jsx("p", {
                children: "forbes.kz",
                className: "paragraph text-gray-landing mt-2"
              })
            ],
            className: "mt-4 lg:mt-0 lg:w-70"
          })
        ],
        className: "block lg:flex justify-between mt-4 lg:mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "shrink-0",
            src: StaticAsset.src("/static/icons/pricing.svg")
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h6", {
                children: aboutPage.pricing_title,
                className: "h6 text-primary"
              }),
              JsxRuntime.jsx("p", {
                children: aboutPage.pricing_subtitle,
                className: "paragraph-small lg:paragraph text-gray-landing"
              })
            ],
            className: "ml-4"
          })
        ],
        className: "mt-6 lg:mt-10 bg-white p-6 rounded-lg flex shadow-price"
      }),
      JsxRuntime.jsx("hr", {
        className: "text-divider mt-6 lg:mt-10"
      }),
      JsxRuntime.jsxs("p", {
        children: [
          Buhta_landing__I18n.trans(intl, "for_cooperation_and_partnership_write_to"),
          JsxRuntime.jsx("a", {
            children: "hello@buhta.com",
            className: "text-primary underline",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "paragraph-small lg:paragraph text-black-landing mt-6 lg:mt-10"
      })
    ],
    className: "pt-10 lg:pt-0 px-6 sm:px-48 lg:px-0"
  });
}

const make = Company;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
